import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';

export type NotInAreaResponse = {
  error?: string;
};

export const createNotInAreaUser = (stateId: string, email: string) =>
  restClient.request<NotInAreaResponse>('/api/v1/onboarding/not_in_area_user', {
    method: 'POST',
    data: snakecaseKeys({
      state: stateId,
      email
    })
  });
